import React, { FunctionComponent, PropsWithChildren, ReactElement } from 'react'

export type PaneProps = PropsWithChildren<{
  className?: string | { wrapper?: string; header?: string; content?: string }
  title: string | ReactElement
  chevron?: FunctionComponent<{ expanded: boolean }>
}>

export const Pane: React.FC<React.PropsWithChildren<PaneProps>> = () => {
  return null
}
